<app-list-notes [notes]="notes" [loading]="loading"></app-list-notes>
